module.exports = __webpack_public_path__ + "img/15.04b5d4aa.png";